import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Check, Plus } from "lucide-react";
import api, { apiError } from "@/lib/api";
import SmartLink from "@/components/SmartLink";
import { today } from "@/lib/dates";

export default function FollowUps() {
  const [items, setItems] = useState([]);
  const [text, setText] = useState("");
  const [due, setDue] = useState(today());

  const load = useCallback(() => {
    api.get("/followups").then((r) => setItems(r.data)).catch((e) => toast.error(apiError(e)));
  }, []);
  useEffect(() => { load(); }, [load]);

  const add = async () => {
    if (!text.trim()) return;
    try {
      await api.post("/followups", { text: text.trim(), due_date: due });
      setText("");
      load();
    } catch (e) { toast.error(apiError(e)); }
  };
  const done = async (f) => { await api.post(`/followups/${f.id}/done`); toast.success("Done"); load(); };
  const push = async (f) => { await api.post(`/followups/${f.id}/push`); toast("Pushed to tomorrow"); load(); };

  return (
    <div data-testid="followups-page" className="pb-4">
      <div className="px-5 pt-8 pb-2">
        <p className="overline-label text-primary">Commitments</p>
        <h1 className="font-display text-4xl tracking-tight text-primary">Follow-ups</h1>
      </div>
      <div className="soft-card mx-4 my-3 p-5 space-y-2">
        <input data-testid="new-followup-input" className="tactical-input" placeholder="Call X, send Y, check on Z..." value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} />
        <div className="flex gap-2">
          <input data-testid="new-followup-date" type="date" className="tactical-input" value={due} onChange={(e) => setDue(e.target.value)} />
          <button data-testid="add-followup-button" onClick={add} className="h-11 px-5 bg-primary text-primary-foreground font-bold text-xs uppercase tracking-widest tap-btn flex items-center gap-1"><Plus size={14} />Add</button>
        </div>
      </div>
      <div className="soft-card mx-4 my-3 divide-y divide-border/60 overflow-hidden">
        {items.length === 0 && <p className="p-6 text-sm text-muted-foreground text-center">Queue is clear.</p>}
        {items.map((f) => (
          <div key={f.id} data-testid={`followup-row-${f.id}`} className="flex items-center gap-2 px-5 py-3.5">
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold">{f.text}</p>
              <p className="text-xs text-muted-foreground font-mono">
                due {f.due_date}
                {f.overdue && <span className="text-destructive ml-2 uppercase tracking-widest text-[10px]">overdue</span>}
                {f.pushed_count > 0 && <span className="ml-2 text-[10px]">pushed x{f.pushed_count}</span>}
                {f.source_link && <SmartLink testId={`fu-email-link-${f.id}`} href={f.source_link} className="text-primary ml-2 underline">email</SmartLink>}
              </p>
            </div>
            <button data-testid={`fu-done-${f.id}`} onClick={() => done(f)} className="h-11 px-3 border border-[#7A9B76] text-[#5f7f5b] text-xs font-bold uppercase tap-btn flex items-center gap-1"><Check size={14} />Done</button>
            <button data-testid={`fu-push-${f.id}`} onClick={() => push(f)} className="h-11 px-3 border border-border text-muted-foreground text-xs font-bold uppercase tap-btn">Push</button>
          </div>
        ))}
      </div>
    </div>
  );
}
